// @flow
import React from 'react';
import styled from 'styled-components';

import { colors } from 'bench-style-constants';

import GustoLogo from './GustoLogo';
import GustoPageLayout from './GustoPageLayout';
import { Spinner } from '../components';

const GustoConnectingText = styled.p`
  color: ${colors.dust};
`;

const GustoSpinnerContainer = styled.div`
  margin-top: 15px;
  svg {
    circle {
      stroke: ${colors.sand};
    }
  }
`;

const GustoLoading = () => (
  <GustoPageLayout>
    <GustoConnectingText>Connecting to</GustoConnectingText>
    <GustoLogo />
    <GustoSpinnerContainer>
      <Spinner />
    </GustoSpinnerContainer>
  </GustoPageLayout>
);

export default GustoLoading;
